// SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>
//
// SPDX-License-Identifier: MPL-2.0

import { writable } from "svelte/store";

function createWebsocketConnection(connectionId) {
	const websocketUrl = `${process.env.API_URL}/ws/${connectionId}`;
	const ws = new WebSocket(websocketUrl);
	setMessageEventListener(ws);

	ws.addEventListener("error", (event) => {
		console.error("⚠️ WebSocket Fehler:", event);
	});
	ws.onclose = () =>
		setTimeout(() => {
			websocket = createWebsocketConnection(connectionId);
		}, 5000);
}

const uuid = window.crypto.randomUUID();
let websocket = createWebsocketConnection(uuid);

const currentErrorMessage = writable("");
const currentWarningMessage = writable("");
const currentInfoMessage = writable("");
const currentDebugMessage = writable("");

const resetStore = writable(0);

// Listen for messages
function setMessageEventListener(ws) {
	ws.addEventListener("message", (event) => {
		try {
			const data = JSON.parse(event.data.trim());
			if (data.message.length === 0) {
				return;
			}
			if (
				data.type &&
				(data.type.toLowerCase() === "error" ||
					data.type.toLowerCase() === "critical")
			) {
				currentErrorMessage.set(data);
			}
			if (data.type && data.type.toLowerCase() === "warning") {
				currentWarningMessage.set(data);
			}
			if (data.type && data.type.toLowerCase() === "info") {
				currentInfoMessage.set(data);
			}
			if (data.type && data.type.toLowerCase() === "debug") {
				currentDebugMessage.set(data);
			}
		} catch (e) {
			console.warn(
				`Received Websocket Message is not valid JSON: ${event.data.trim().toString()}`,
			);
		}
	});
}

const sendMessage = (message) => {
	if (websocket.readyState <= 1) {
		websocket.send(message);
	}
};

const resetMessages = () => {
	//somehow trigger resetStore to get update event in components
	resetStore.update((n) => n + 1);
};

export default {
	currentMessage: {
		error: currentErrorMessage,
		warning: currentWarningMessage,
		info: currentInfoMessage,
		debug: currentDebugMessage,
		reset: resetStore,
	},
	websocket: {
		sendMessage: sendMessage,
		resetMessages: resetMessages,
	},
	uuid: uuid,
};
